import { DeliveryRecapItem } from '@/api/receive';
import { PaginationList } from '@/components/layout/PaginationList';
import { UIBox } from '@/components/ui/Box';

import { Typography } from '@/components/ui/Typography';
import React from 'react';

import { useTranslation } from 'react-i18next';
import ProductTableRow from './ProductTableRow';
import { StyledGrid, StyledGridHeader } from './style';
import { ProductTableProps } from './types';

const ProductTable: React.FC<ProductTableProps> = ({ data, flowType }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledGrid padding="0 24px">
        <StyledGridHeader>
          <Typography font="heavy">{t('product.brandDescription')}</Typography>
          <Typography font="heavy">{t('product.upcCode')}</Typography>
          <Typography font="heavy" className={'text-number'}>
            {t('receiving.expectedqty')}
          </Typography>
          <Typography font="heavy" className={'text-number'}>
            {t('receiving.qtysold')}
          </Typography>
          <Typography font="heavy" className={'text-number'}>
            {t('receiving.qtyFound')}
          </Typography>
          <Typography font="heavy" className={'text-number'}>
            {t('receiving.qtytotalfound')}
          </Typography>
          <Typography font="heavy" className={'text-number'}>
            {t('receiving.adj')}
          </Typography>
        </StyledGridHeader>

        <PaginationList
          data={data}
          pageSize={20}
          noItems={
            <UIBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginTop="10%"
            >
              <Typography font="heavy" color="grey">
                {t('noItems')}
              </Typography>
            </UIBox>
          }
          renderItem={(product: DeliveryRecapItem): JSX.Element =>
            product && (
              <ProductTableRow
                qtySold={product.qtySold}
                quantity={product.quantity}
                qtyFound={product.qtyFound}
                qtyTotalFound={product.qtyTotalFound}
                adj={product.adj}
                key={product.upcCode}
                brandDescription={product.brandDescription}
                upcCode={product.upcCode}
                movementType={product.movementType}
                flowType={flowType}
              />
            )
          }
        />
      </StyledGrid>
    </>
  );
};

export default ProductTable;
